const title = '远望谷'
const getTitle = function(til) {
  let allTitle = til + '-' + title
  return allTitle
}
export default getTitle